<template>
    <div class="field-renderer-bool">
        <input
            ref="inputref"
            class="ag-input-field-input"
            type="radio"
            :checked="value"
            value="true"
            @click="click"
            readonly="true"
        />
    </div>
</template>
<script setup lang="ts">
import { ref } from 'vue';

const prop = withDefaults(
    defineProps<{
        value: boolean;
    }>(),
    { value: false },
);

const inputref = ref();

const click = () => {};

/**
 * Expose the focus method
 
 */
defineExpose({
    /**
     * Focus the input
     */
    focus: () => inputref.value?.focus(),
});
</script>
